<template>
  <v-dialog
    v-model="show"
    persistent
    width="900"
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <template
      v-for="(_, scopedSlotName) in $scopedSlots"
      #[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>
    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
    <v-card :loading="isLoading" :disabled="isLoading">
      <v-card-title>
        <div>Generate Jadwal untuk {{ classroom.name }} ?</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <p>
          Proses ini akan <strong>menghapus semua jadwal kelas</strong>
          {{ classroom.name }} yang <strong>belum selesai</strong>, kemudian
          men-generate jadwal-jadwal kelas bedasarkan data terbaru
        </p>
        <p>
          Jadwal kelas yang <strong>sudah selesai</strong> tidak akan berubah.
        </p>
        <v-row>
          <v-col cols="12">
            <v-switch v-model="isGenerateAll" inset label="Generate semua?">
            </v-switch>
            <div>
              Jika diaktifkan, maka akan men-generate jadwal dari tanggal start
              &amp; end dari kelas ini. Selain itu,
              <strong>tentukan tanggal start &amp; end</strong> untuk jadwal
              kelas yang ingin di generate
            </div>
          </v-col>
          <v-col v-show="!isGenerateAll" cols="12" md="6">
            <div class="label mb-2">Generate Start Date</div>
            <v-menu
              ref="startDateMenu"
              v-model="startDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="startDate"
                  placeholder="Select generate start date"
                  prepend-icon="mdi-calendar"
                  solo
                  flat
                  outlined
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                @change="$refs.startDateMenu.save(startDate)"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col v-show="!isGenerateAll" cols="12" md="6">
            <div class="label mb-2">Generate End Date</div>
            <v-menu
              ref="endDateMenu"
              v-model="endDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template #activator="{ on, attrs }">
                <v-text-field
                  v-model="endDate"
                  placeholder="Select generate end date"
                  prepend-icon="mdi-calendar"
                  solo
                  flat
                  outlined
                  dense
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="endDate"
                @change="$refs.endDateMenu.save(endDate)"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-end">
        <v-btn depressed outlined @click="show = false">Cancel</v-btn>
        <v-btn
          depressed
          color="primary"
          :disabled="isLoading"
          @click="clickConfirm"
          >Confirm</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'GenerateClassroomScheduleDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    classroom: {
      type: Object,
      required: true,
    },
    defaultStartDate: {
      type: [Date, String],
      default: () => new Date(),
      required: false,
    },
    defaultEndDate: {
      type: [Date, String],
      default: () => new Date(),
      required: false,
    },
    submitApi: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      startDateMenu: false,
      startDate: null,
      endDateMenu: false,
      endDate: null,
      isGenerateAll: true,
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'classroom/isGenerateSchedulesLoading',
    }),
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {
    if (this.defaultStartDate) {
      this.startDate =
        this.defaultStartDate instanceof Date
          ? this.formatDate(this.defaultStartDate)
          : this.defaultStartDate
    }
    if (this.defaultEndDate) {
      this.endDate =
        this.defaultEndDate instanceof Date
          ? this.formatDate(this.defaultEndDate)
          : this.defaultEndDate
    }
  },
  methods: {
    ...mapActions({ generateSchedules: 'classroom/generateSchedules' }),
    async clickConfirm() {
      const start_date = !this.isGenerateAll ? this.startDate : null
      const end_date = !this.isGenerateAll ? this.endDate : null
      if (this.submitApi) {
        const err = await this.generateSchedules({
          id: this.classroom.id,
          start_date,
          end_date,
        })
        if (!err) {
          this.show = false
          this.$emit('submit')
        }
      } else {
        this.$emit('confirm', {
          startDate: start_date,
          endDate: end_date,
        })
      }
    },
  },
}
</script>
